import { useReactiveVar } from '@apollo/client'
import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { processEnv } from 'components/configuration/environmentVariables'
import React, { FC, useEffect } from 'react'
import FamilySection from './FamilySection'
import FirmNameAutoCompleteInput from './FirmNameAutoCompleteInput'
import ListingTypeAutoCompleteInput from './ListingTypeAutocompleteInput'
import ProductModelNumberInput from './ProductModelNumberInput'
import ProductNameInput from './ProductNameInput'
import ProductTypeSection from './ProductTypeSection'
import {
    addProductDialogState,
    setProductDialogState,
} from './addProductFormHandler'
import { useAddProductFormStyles } from './formStyles'

const isBadgelessCardsEnabled =
    processEnv.REACT_APP_EnableBadgelessCards === '1'

const AddProductForm: FC = () => {
    const { type } = useReactiveVar(addProductDialogState)

    const classes = useAddProductFormStyles()

    useEffect(() => {
        if (isBadgelessCardsEnabled) {
            setProductDialogState({ type: ListingLevel.ProductListing })
        }
    }, [])

    return (
        <GridContainer
            data-testid="addProductContainer"
            spacing={2}
            className={classes.addProductContainer}
        >
            {!isBadgelessCardsEnabled && <ListingTypeAutoCompleteInput />}
            {(isBadgelessCardsEnabled || !!type) && (
                <>
                    <FirmNameAutoCompleteInput />
                    <FamilySection />
                    <ProductTypeSection />
                    <ProductModelNumberInput />
                    <ProductNameInput />
                </>
            )}
        </GridContainer>
    )
}

export default AddProductForm
